import { render } from "./Coupons.vue?vue&type=template&id=8a311624"
import script from "./Coupons.vue?vue&type=script&lang=js"
export * from "./Coupons.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__